import { REST_API } from '../../constants/restUrls';
import HttpConnection from '../../utils/http-connection';

/**
 * 検索条件から権限一覧を取得する
 *
 * @param {*} searchCondition
 * @returns
 */
export function getDatas(searchCondition) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .get(REST_API.USER.ROLE.ROLES, searchCondition)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}

/**
 * 削除処理
 *
 * @param {*} param
 * @returns
 */
export function deleteRoles(param) {
  const httpConnection = new HttpConnection();

  return httpConnection
    .deletes(REST_API.USER.ROLE.ROLES, param)
    .then((response) => Promise.resolve(response))
    .catch((error) => Promise.reject(error));
}
